import { connect } from 'react-redux';
import { get } from 'lodash';
import { selectChargerConfigurationModule, unlockChargerConfiguration } from '../../actions';
import ChargerConfigurationForm from './ChargerConfiguration';
import { chargerConfigurationFormId } from './constants';

const mapStateToProps = (state) => ({
  selectedModule: state.chargerDetails.selectedConfigurationModuleName,
  configurationForm: state.form[chargerConfigurationFormId],
  online: get(state, 'chargerDetails.currentCharger.i2p2_state.c_online', false),
  fullState: get(state, 'chargerDetails.currentCharger.c_full_state', []),
});

const mapDispatchToProps = (dispatch) => ({
  selectChargerConfigurationModule: (moduleName) => dispatch(selectChargerConfigurationModule(moduleName)),
  unlockConfig: (chargerUUID) => dispatch(unlockChargerConfiguration(chargerUUID)),
});

export const ChargerConfiguration = connect(mapStateToProps, mapDispatchToProps)(ChargerConfigurationForm);
